import { backendEndpoints } from '$/services/endpoints';
import { fetcher } from '$/services/fetcher';
import { GeneralBackendResponseObjectSchema } from '$/services/mapper/authentication';
import { validateToken } from '$/services/usecases/authentication';
import { type User } from '$/services/usecases/authentication/mapper/genericCloudResponse';

export type ProfileData = Pick<User, 'firstName' | 'lastName' | 'email'>;

export const updateCountry = async (country: string) => {
  await validateToken();
  return await fetcher(backendEndpoints.CHANGE_COUNTRY_URL, {
    body: { country },
    method: 'PATCH',
    parser: (data) => GeneralBackendResponseObjectSchema.parse(data),
    includeCredentials: true,
  });
};

export const deleteAccount = async () => {
  await validateToken();
  return await fetcher(backendEndpoints.DELETE_ACCOUNT, {
    method: 'DELETE',
    parser: (data) => GeneralBackendResponseObjectSchema.parse(data),
    includeCredentials: true,
  });
};
